

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_ToggleSwitchCore";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_ToggleSwitchCore__root","input":"wds_1_220_3_ToggleSwitchCore__input","track":"wds_1_220_3_ToggleSwitchCore__track","knob":"wds_1_220_3_ToggleSwitchCore__knob","knobIcon":"wds_1_220_3_ToggleSwitchCore__knobIcon"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




